<div class="checkbox">
    <svg-icon (click)="markMultipleFiles(false)" *ngIf="questionForm.controls.allowMultipleFiles.value" svgClass="svg-img img"
        src="/assets/images/display-question/checkbox.svg"></svg-icon>
    <img class="img" (click)="markMultipleFiles(true)" *ngIf="!questionForm.controls.allowMultipleFiles.value"
        src="/assets/images/display-question/checkbox-empty.svg">
    <p>{{'questionBoard.edit.uploadFile.allowMultipleFiles'| translate}}</p>
</div>

<div class="checkbox">
    <svg-icon (click)="markIconUploadFile(false)" *ngIf="questionForm.controls.isIconUploadFile.value" svgClass="svg-img img"
        src="/assets/images/display-question/checkbox.svg"></svg-icon>
    <img class="img" (click)="markIconUploadFile(true)" *ngIf="!questionForm.controls.isIconUploadFile.value"
        src="/assets/images/display-question/checkbox-empty.svg">
    <p>{{'questionBoard.edit.upload'| translate}}</p>
</div>